import { Cdn } from 'utils/assets'

export default {
  GOOGLE_STORE_LOGO: Cdn.getAssetUrl(
    'arvore-library-assets/banner-google-play@3x.png'
  ),
  GOOGLE_STORE_LINK:
    'https://play.google.com/store/apps/details?id=arvoredelivros.com.br.arvore&hl=en',
  APPLE_STORE_LOGO: Cdn.getAssetUrl(
    'arvore-library-assets/banner-app-store@3x.png'
  ),
  APPLE_STORE_LINK:
    'https://apps.apple.com/br/app/arvore-de-livros/id1094879125'
}

export const getYear = new Date().getFullYear()
